import React from 'react'
import styled from 'styled-components'

export default function VerticleBar() {
  return (
    <Wrapper />
  )
}

const Wrapper = styled.span`
  margin: 3px;
  width: 2px;
  background-color: black;
`
